import http from '@/http-common'
import global from '../../utils/global'
import Title from '../TitlePage'

export default {
  name: 'SpravList',
  components: {Title},
  props: {
    stacked: {
      type: Object,
      default: function () {
        return {flg: false, size: 'sm'}
      }
    },
    showCaption: {
      type: Boolean,
      default: true,
    },
    modalLoadOpened: {
      type: Boolean,
      default: false,
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    captionTab: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: []
    },
    columns: {
      type: Array,
      default: []
    },
    isCalled: {
      type: Boolean,
      default: false,
    },
    isViewBtn: {
      type: Boolean,
      default: true,
    },
    selectValue: {
      type: Object,
      default: null
    },
    urls: {
      type: Object,
      default: function () {
        return {
          save: '',
          delete: ''
        }
      }
    },
    captionSpr: {
      type: Object,
      default: null
    },
    heightTab: {
      type: String,
      default: "65vh"
    },
    darkStyle: {
      type: Boolean,
      default: true
    },
    showFooter: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    getBack() {
      return "background: rgba(255, 255, 150, 0.8);"
    },
    getColor() {
      return "theadColor"
    },
    titleSpr: function () {
      return "Добавить " + this.captionSpr.nameR
    },
    widthCol: function () {
      return {
        'col-md-4': this.isCalled,
        'col-md-3': !this.isCalled,
      }
    },
    classRow: function () {
      return 'col-xs-12 col-sm-12 col-md-12 col-lg-12'
      // 'col-xs-12 col-sm-12 col-md-12 col-lg-12': this.isCalled,
      // 'col-xs-12 col-sm-12 col-md-12 col-lg-12': !this.isCalled
    },
    countRecord: function () {
      return this.items.length;
    }
  },
  data() {
    return {
      fields: [],
      currentPage: 1,
      perPage: 10,
      totalRows: 1,
      pageOptions: [10, 15, 20],
      filter: null,
      selectMode: 'single',
      selected: [],
      selectedItem: {id: null},
      confirm_dialog: false,
      countRows: 0,
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  created() {
    this.totalRows = this.items.length;
    this.fields = this.columns
    this.fields.forEach(function (x) {
      x.thAttr = {style: 'background-color: #293f50; color: white'};
    })
    window.addEventListener('resize', this.onResize);
    this.onResize();
  },
  watch: {
    selectedItem: function (val) {
      if (val !== false) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onResize() {
      // Small (sm) <=540px
      if (document.documentElement.clientWidth > global.isMobileWidth()) {
        this.stacked.flg = false
        this.stacked.size = 'sm'
        this.fields.forEach(function (x) {
          x.class = x.firstClass;
        })
      } else {
        this.stacked.flg = true
        this.stacked.size = 'sm'
        this.fields.forEach(function (x) {
          x.class = null;
        })
      }
    },
    getStacked() {
      if (this.stacked.flg) {
        return this.stacked.size;
      } else {
        return false;
      }
    },
    rowSelected(items) {
      this.selected = items;
      //var rec = this.selectedItem;
      for (var key in items[0]) {
        this.selectedItem[key] = items[0][key];
      }
      //this.selectedItem = rec;
      this.$emit('input', this.selectedItem)
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1
    },
    cleanItem() {
      for (var key in this.selectedItem) {
        if (typeof this.selectedItem[key] == 'string') {
          this.selectedItem[key] = null
        } else if (typeof this.selectedItem[key] == 'array') {
          this.selectedItem[key] = []
        } else {
          this.selectedItem[key] = null
        }
      }
    },
    add() {
      if (this.items.length > 0) {
        this.rowSelected([this.items[0]]);
      }
      this.cleanItem();
      this.$emit('editItem')
    },
    save(rec) {
      var addFlag = false;
      if (!rec.id || rec.id === 0) {
        addFlag = true;
      }
      var data = rec;
      var vm = this;
      http.post(this.urls.save, data)
      .then((res) => {
        var dataR = res.data;
        if (dataR.id > 0) {
          const index = vm.items.map(e => e.id).indexOf(data.id);
          if (index >= 0) {
            for (var key in dataR) {
              vm.items[index][key] = dataR[key];
            }
          }
          if (addFlag) {
            this.items.push(dataR)
          }
          this.$emit('closeEdit')
        } else {
          if (dataR.error_mess) {
            alert(dataR.error_mess)
          } else {
            alert("Ошибка сохранения!!!")
          }
        }
      }).catch(function (error) {
        if (error.response.status === 403) {
          alert("Нет прав!")
        } else {
          console.error(error.response.data.message)
          alert("Ошибка сохранения на сервере!!!")
        }
      })
    },
    deleteItem() {
      var vm = this;
      var id_rec = vm.selectedItem.id;
      var token = localStorage.getItem('token');
      http.delete(this.urls.delete + "/" + id_rec, {headers: {Authorization: 'Bearer_' + token}})
      .then((res) => {
        var result = res.data;
        if (result === "success") {
          const index = vm.items.map(e => e.id).indexOf(id_rec);
          if (index >= 0) {
            vm.items.splice(index, 1)
          }
        } else {
          alert("Ошибка удаления позиции!!!")
        }
      }).catch(function (err) {
        alert("Ошибка удаления позиции!!! (" + err.response.data.message + ")")
      })
    },
    showConfirmDlg(rec) {
      this.rowSelected([rec]);
      this.confirm_dialog = true;
    },
    editSpr(rec) {
      this.rowSelected([rec]);
      this.$emit('editItem')
    },
    updateData() {
      this.$emit('updateData')
    },
    getColorCell(item) {
      if (item.colorBackground || item.colorFont) {
        return 'background: ' + item.colorBackground + '; color: ' + item.colorFont;
      } else {
        return ''
      }
    },
    getPhonesStr(row) {
      return row.phones.map(e => e.phone).join()
    },
  }
}
